import { render } from "./Administration.vue?vue&type=template&id=312d3a88&scoped=true"
import script from "./Administration.vue?vue&type=script&lang=js"
export * from "./Administration.vue?vue&type=script&lang=js"

import "./Administration.vue?vue&type=style&index=0&id=312d3a88&lang=scss&scoped=true"
import "./Administration.vue?vue&type=style&index=1&id=312d3a88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312d3a88"]])

export default __exports__